import { type JSX } from 'react'
import { FormattedMessage } from 'react-intl'

type NfcLandingPageFaqDataItem = {
  details: JSX.Element
  key: string
  summary: JSX.Element
}

export const NfcLandingPageFaqData: NfcLandingPageFaqDataItem[] = [
  {
    details: <FormattedMessage id="nfc.faq.doINeedTheApp.details" />,
    key: '0-faq',
    summary: <FormattedMessage id="nfc.faq.doINeedTheApp.summary" />,
  },
  {
    details: <FormattedMessage id="nfc.faq.cards.details" />,
    key: '1-faq',
    summary: <FormattedMessage id="nfc.faq.cards.summary" />,
  },
  {
    details: <FormattedMessage id="nfc.faq.canIUseIt.details" />,
    key: '2-faq',
    summary: <FormattedMessage id="nfc.faq.canIUseIt.summary" />,
  },
  {
    details: <FormattedMessage id="nfc.faq.familyPrescriptions.details" />,
    key: '3-faq',
    summary: <FormattedMessage id="nfc.faq.familyPrescriptions.summary" />,
  },
  {
    details: <FormattedMessage id="nfc.faq.seePrescription.details" />,
    key: '4-faq',
    summary: <FormattedMessage id="nfc.faq.seePrescription.summary" />,
  },
]
